<template>
    <footer class="footer has-cards">
        <div class="container container-lg">
            <div class="row">
              <br>
            </div>
        </div>
        <div class="container">
            <div class="row row-grid my-md">
              <div class="col-md-8">
              </div>
              <div class="col-md-4">
                <h2>Powered by</h2>
                <img src="/img/APG_logo_transparant.png" width="350px;">
              </div>
            </div>
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        &copy; {{year}} devConf
                    </div>
                </div>

            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
</style>
